import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import styled, { ThemeProvider } from 'styled-components';
import crioTheme from '@crio/crio-react-component/dist/cjs/config/crioTheme';
import firebase from 'firebase/compat/app';
import { Box } from '@mui/material';
import { TraitsReconciliationContextProvider } from '../context/TraitsReconciliationContext';
import { useFetchUnmappedRecords } from '../api/esourceService';
import { getTokenFromCookie } from '../util/storage';
import UnmappedRecords from './Traits/UnmappedRecords';
import User = firebase.User;
import TraitsReconciliationInstructions from './Traits/TraitsReconciliationInstructions';
import StudySelector from './Traits/StudySelector';
import ProcedureSelector from './Traits/ProcedureSelector';

const TraitsBox = styled(Box)(({ theme }) => `{
    background-color: ${theme.palette.grey[200]};
    min-height: 100%;
    padding: 20px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
}`);

function TraitsReconciliation() {
  const { siteId, patientId } = useParams();
  const [currentUser, setCurrentUser] = useState<User | null>(null);
  const { unmappedRecords, isLoading: isLoadingUnmappedRecords } = useFetchUnmappedRecords(siteId, patientId, currentUser);

  useEffect(() => {
    // Add class to html and body for iframe embedding
    document.documentElement.classList.add('traits-reconciliation-iframe');
    document.body.classList.add('traits-reconciliation-iframe');
  }, []);

  useEffect(() => {
    const initializeSession = async () => {
      const cookieJwt = getTokenFromCookie();
      await firebase.auth().setPersistence('none')
        .then(() => {
          firebase.auth().onAuthStateChanged(setCurrentUser);
          if (cookieJwt && !firebase.auth().currentUser) {
            firebase.auth().signInWithCustomToken(cookieJwt);
          }
        })
        .catch((err) => {
          console.log(err); // eslint-disable-line no-console
        });
    };

    initializeSession();
  }, [currentUser]);

  return (
    <ThemeProvider theme={{ ...crioTheme }}>
      <TraitsReconciliationContextProvider unmappedRecords={unmappedRecords || []} siteId={siteId} patientId={patientId}>
        <TraitsBox>
          <TraitsReconciliationInstructions />
          <StudySelector />
          <ProcedureSelector />
          <UnmappedRecords isLoadingUnmappedRecords={isLoadingUnmappedRecords} currentUser={currentUser} />
        </TraitsBox>
      </TraitsReconciliationContextProvider>
    </ThemeProvider>
  );
}

export default TraitsReconciliation;
